// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M10.5 15C12.1569 15 13.5 16.3431 13.5 18C13.5 19.6569 12.1569 21 10.5 21C8.84315 21 7.5 19.6569 7.5 18C7.5 16.3431 8.84315 15 10.5 15Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M10.5 8.5L19 11L14.4502 17.3691C14.1477 15.4598 12.4945 14 10.5 14L11.5 13L4.5 10L12.4971 3.99316L10.5 8.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-git-commit-1-filled')
export default class GitCommit1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'git-commit-1-filled',
    }
  }
}
